const appConfig = {
  "name": "account-admin-v2-test",
  "version": "0.1.0",
  "stage": "test",
  "deployThisBuild": false,
  "okta": {
    "issuer": "https://okta.mit.edu/oauth2/aus6shd5478WH30vd697",
    "clientId": "27s94s6joet51c235ihkttcqse",
    "redirectUris": [
      "https://account-admin-v2.atlas-apps-test.mit.edu"
    ],
    "postLogoutRedirectUris": [
      "https://account-admin-v2.atlas-apps-test.mit.edu/logout"
    ],
    "scopes": [
      "account/admin",
      "account/duo",
      "account/password",
      "account/register",
      "digital-id/search",
      "digital-id/user",
      "openid",
      "profile",
      "system/action.query-roles",
      "user/action.admin-account",
      "user/action.configure-duo-account",
      "user/action.register-mitid-account",
      "user/action.reset-kerberos-password",
      "user/all"
    ]
  },
  "amplify": {
    "userPoolId": "us-east-1_nY154N4yV",
    "userPoolWebClientId": "27s94s6joet51c235ihkttcqse",
    "oauth": {
      "domain": "atlas-auth-test.mit.edu",
      "scope": [
        "account/admin",
        "account/duo",
        "account/password",
        "account/register",
        "digital-id/search",
        "digital-id/user",
        "openid",
        "profile",
        "system/action.query-roles",
        "user/action.admin-account",
        "user/action.configure-duo-account",
        "user/action.register-mitid-account",
        "user/action.reset-kerberos-password",
        "user/all"
      ],
      "redirectUris": [
        "https://account-admin-v2.atlas-apps-test.mit.edu"
      ],
      "postLogoutRedirectUris": [
        "https://account-admin-v2.atlas-apps-test.mit.edu/logout"
      ],
      "responseType": "token",
      "options": {
        "AdvancedSecurityDataCollectionFlag": false
      }
    }
  }
};
export default appConfig;